.icon-button {
    &:focus {
        outline: unset !important;
    }
}